import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_CONFIG_MESSAGES = "GET_CONFIG_MESSAGES";
export const RE_LOADING = "RE_LOADING";
export const ADD_CONFIG_MESSAGES = "ADD_CONFIG_MESSAGES";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});

export const GetConfigMessagesByBadge = (Badge) => {
  var Token = convertSHA()
  return  dispatch =>{
    instance.get(`/ConfiguracionMensajes/GetConfigMensaje/${Badge}&${Token}`).then((res => {
        dispatch({
            type: GET_CONFIG_MESSAGES,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const addConfigMessages = data =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: RE_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/ConfiguracionMensajes/PutInsertaActualizaConfigMensaje/${data.badge}&${data.active}&${Token}` ).then((res => {
            dispatch({
                type: ADD_CONFIG_MESSAGES,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}
